import React from 'react'
import { Chip, Stack, Typography } from '@mui/material'

interface ToggleAllSymbolsButtonsProps {
  toggleAllSymbols: (val: boolean) => void
}

const FRToggleAllSymbolsButtons: React.FC<ToggleAllSymbolsButtonsProps> = ({ toggleAllSymbols }) => {
  return (
    <Stack direction='row' columnGap={1} sx={{ display: 'flex', alignItems: 'center' }}>
      <Typography fontSize='small'>
        Symbols:
      </Typography>
      <Chip
        label='Select All'
        onClick={() => {
          toggleAllSymbols(true)
        }}
        variant='outlined'
        size='small'
      />
      <Chip
        label='Deselect All'
        onClick={() => {
          toggleAllSymbols(false)
        }}
        variant='outlined'
        size='small'
      />
    </Stack>
  )
}

const MemoizedToggleAllSymbolsButtons = React.memo(FRToggleAllSymbolsButtons)

export default MemoizedToggleAllSymbolsButtons
